import React from "react";
export function DropdownIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         version="1.1" x="0px" y="0px"
         viewBox="0 30 100 125"
         fill="#000"
    >
    <g>
        <polygon points="67.64,43.3 64.81,40.47 50,55.28 35.19,40.47 32.36,43.3 50,60.94  " />
    </g>
</svg>
  );
}